import React, { useState } from 'react';

import { Link as IconLink, Checkmark } from '@digital-hig/icon';
import cn from 'classnames';
import { InlineShareButtons, SharingNetwork } from 'sharethis-reactjs';

export interface Props {
  displayCopyURL?: boolean;
  networks: SharingNetwork[];
  url?: string;
  title: string;
  theme?: 'default' | 'white';
}
/*
 * Displays a ShareThis wrapper component.
 * @param {*} props Component properties
 * @returns {ReactComponent} share component.
 */
function Share({
  displayCopyURL,
  networks,
  url,
  title,
  theme = 'default',
}: Props) {
  const [isURLCopied, setURLCopied] = useState(false);

  /**
   * Copies the URL into the clipboard and sets/resets isURLCopied state.
   */
  const handleCopyURL = () => {
    const el = document.createElement('input');
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setURLCopied(true);

    setTimeout(() => {
      setURLCopied(false);
    }, 1500);
  };

  return (
    <div className={cn('au-share', { 'au-share--white': theme === 'white' })}>
      {displayCopyURL && (
        <button
          type="button"
          aria-label="share-button"
          className={cn('au-share-button', {
            'is-copied': isURLCopied,
            'au-share-button--white': theme === 'white',
          })}
          onClick={handleCopyURL}
        >
          <Checkmark />
          <IconLink />
        </button>
      )}
      <InlineShareButtons
        config={{
          alignment: 'left',
          color: 'social',
          enabled: true,
          font_size: 16,
          labels: null,
          language: 'en',
          networks,
          padding: 12,
          radius: 100,
          show_total: false,
          size: 40,
          url,
          title,
        }}
      />
    </div>
  );
}

export default Share;
